export default __webpack_public_path__ + "static/media/defendant2.bce89e55.png";